import { CircleMinusIcon, CirclePlusIcon, IconButton } from "../../General";
import { Stack } from "../../Layout";
import { FormInput } from "../_partials";

import styles from "./NumberStepperField.module.scss";

interface StepperProps {
    editable?: boolean;
    id: string;
    inputRef?: React.Ref<HTMLInputElement>;
    isMaxDisabled?: boolean;
    isMinDisabled?: boolean;
    label: string;
    max?: number;
    min?: number;
    name: string;
    onChange: (value: number) => void;
    step?: number;
    value: number;
}

export function Stepper({
    editable = false,
    id,
    inputRef,
    isMaxDisabled = false,
    isMinDisabled = false,
    label,
    max,
    min = 0,
    name,
    onChange,
    step = 1,
    value,
}: StepperProps) {
    const handleDecrement = () => {
        if (value <= min) return;
        onChange(value - step);
    };

    const handleIncrement = () => {
        if (max && value >= max) return;
        onChange(value + step);
    };

    const handleOnInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!editable) return;
        const int = parseInt(e.target.value, 10);

        if (Number.isNaN(int)) {
            onChange(0);
            return;
        }

        onChange(int);
    };

    const handleOnFocusInput = (e: React.FocusEvent<HTMLInputElement>) => {
        if (!editable) return;
        e.target.select();
    };

    return (
        <Stack alignItems="center" className={styles["stepper"]} direction="row">
            <IconButton
                aria-controls={name}
                aria-label={`decrement ${label}`}
                disabled={isMinDisabled || value === 0 || (min ? value <= min : false)}
                edge="start"
                onClick={handleDecrement}
            >
                <CircleMinusIcon size="large" />
            </IconButton>
            <div>
                <FormInput
                    className={styles["stepper-fieldset"]}
                    id={id}
                    inputClassName={styles["stepper-input"]}
                    inputRef={inputRef}
                    name={name}
                    onChange={handleOnInputChange}
                    onFocus={handleOnFocusInput}
                    readOnly={!editable}
                    value={value.toString()}
                />
            </div>
            <IconButton
                aria-controls={name}
                aria-label={`increment ${label}`}
                disabled={isMaxDisabled || (max !== undefined ? value >= max : false)}
                onClick={handleIncrement}
            >
                <CirclePlusIcon size="large" />
            </IconButton>
        </Stack>
    );
}
